import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { ContractDocumentPreview, type ContractDocumentPreviewProps } from './ContractDocumentPreview';

interface SignedContractViewProps {
  /** Rendered read-only: pass no onEdit* callbacks. */
  preview: ContractDocumentPreviewProps;
  version?: number;
  /** Starts an ÄTA contract linked to this one; omit when ÄTA is not possible. */
  onCreateVariation?: () => void;
}

/** Edit mode for a contract signed by both parties: the valid version, and the way forward (ÄTA). */
export function SignedContractView({ preview, version, onCreateVariation }: SignedContractViewProps) {
  const { t } = useTranslation();
  const ids = useId();

  return (
    <div className="contract-wizard-step">
      <header className="mb-4">
        <p className="contract-wizard-kicker mb-1">
          {version ? t('contracts.wizard.edit.signed.kickerWithVersion', { version }) : t('contracts.wizard.edit.signed.kicker')}
        </p>
        <h2 className="contract-wizard-step-title">{t('contracts.wizard.edit.signed.title')}</h2>
        <p className="text-muted mb-0">{t('contracts.wizard.edit.signed.intro')}</p>
      </header>

      <div className="contract-wizard-review">
        <ContractDocumentPreview {...preview} chipLabel={t('contracts.wizard.edit.signed.chip')} />

        {onCreateVariation && (
          <aside className="contract-wizard-sign-panel" aria-labelledby={`${ids}-ata`}>
            <h3 id={`${ids}-ata`} className="contract-wizard-section-title">{t('contracts.wizard.edit.signed.ataTitle')}</h3>
            <p className="mb-0">{t('contracts.wizard.edit.signed.ataText')}</p>
            <button type="button" className="btn contract-wizard-btn-navy" onClick={onCreateVariation}>
              <i className="feather-plus me-2" aria-hidden="true"></i>
              {t('contracts.wizard.edit.signed.ataButton')}
            </button>
          </aside>
        )}
      </div>
    </div>
  );
}

export default SignedContractView;
